// Podtemat 5 - zadania zamkniete egzaminu osmoklasisty z dzialu VIII (stereometria).

import * as CuboidSurface from "../../temat1_graniastoslupy/podtemat2_pole_powierzchni_graniastoslupow_types/E8CuboidSurfaceAreaClosedTask";
import * as StackedCubesSurface from "../../temat1_graniastoslupy/podtemat2_pole_powierzchni_graniastoslupow_types/E8StackedCubesSurfaceAreaClosedTask";

export const registry = {
  E8CuboidSurfaceAreaClosedTask: CuboidSurface,
  E8StackedCubesSurfaceAreaClosedTask: StackedCubesSurface,
};

export function generateTasks(options = {}) {
  return [StackedCubesSurface.generateTask(options), CuboidSurface.generateTask(options)];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 closed task type in stereometria: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}
